module.exports = __webpack_public_path__ + "img/motor_no64.1f9fb67a.jpg";